'use client';

import { useMemo } from 'react';
import { useAuth } from '@/hooks/use-auth';

export function useSelfAttribution() {
  const { entrant, user } = useAuth({ hydrateFromQuery: true });

  return useMemo(() => {
    if (!entrant || !user) return undefined;
    return {
      entrantId: entrant.id,
      firstName: entrant.firstName,
      lastName: entrant.lastName,
      email: user.email,
    };
  }, [entrant, user]);
}
